import { useI18n } from 'vue-i18n';

export const useThemes = () => {
  const { t } = useI18n();

  const items = [
    {
      title: t('messages.useDeviceTheme'),
      value: 'auto',
    },
    {
      title: t('messages.darkTheme'),
      value: 'dark',
    },
    {
      title: t('messages.lightTheme'),
      value: 'light',
    },
  ];

  return {
    items,
  };
};
